import React, { useState, useEffect } from 'react';
import { debugLog } from '../../../../utils/debug';
import { getAccountSharing, handleInvite } from '../../../../controllers/Doctor/AccountControllers';


const AccountSharing = () => {
    const [accountSharing, setAccountSharing] = useState([]);
    const [nameInput, setNameInput] = useState('');
    const [emailInput, setEmailInput] = useState('');
    const [submitting, setSubmitting] = useState(false);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        handleGetAccountSharing();
    }, []);

    const handleGetAccountSharing = async () => {
        setLoading(true);
        const accountSharing = await getAccountSharing();
        debugLog('accountSharing', accountSharing);
        setAccountSharing(accountSharing);
        setLoading(false);
    };

    

    return (
        <div className='dc-tabscontent tab-content'>
            <h1 style={{ marginBottom: '12px' }}>Account Sharing</h1>

            <div className='row' style={{
                alignItems: 'center',
                justifyContent: 'space-between',
                gap: '12px',
                background: '#f7f7f9',
                border: '1px solid #ececf1',
                borderRadius: 8,
                padding: '12px 16px',
                marginBottom: 16,
                marginRight: 0,
                marginLeft: 0
            }}>
                <div style={{ color: '#555', fontSize: 14 }}>
                    Share limited access by inviting teammates via email. You can revoke access anytime.
                </div>
                <div className='row' style={{ alignItems: 'center', gap: 8, marginRight: 0, marginLeft: 0 }}>
                    <input
                        type="text"
                        placeholder="Enter name"
                        value={nameInput}
                        className='form-control'
                        onChange={(e) => setNameInput(e.target.value)}
                        style={{
                             width: 'revert'
                        }}
                    />
                    <input
                        type="email"
                        placeholder="Enter email"
                        value={emailInput}
                        className='form-control'
                        onChange={(e) => setEmailInput(e.target.value)}
                        style={{
                            width: 'revert'
                        }}
                    />
                    <button
                        onClick={() => handleInvite(nameInput, emailInput, setSubmitting, handleGetAccountSharing, setNameInput, setEmailInput)}
                        disabled={submitting}
                        className='dc-btn dc-btn-primary'
                    >
                        {submitting ? 'Inviting…' : 'Invite'}
                    </button>
                </div>
            </div>

            <div style={{
                border: '1px solid #ececf1',
                borderRadius: 8,
                overflow: 'hidden'
            }}>
                <div style={{
                    display: 'grid',
                    gridTemplateColumns: '2fr 2fr 1fr',
                    gap: 8,
                    background: '#fafafa',
                    padding: '10px 12px',
                    fontWeight: 600,
                    color: '#444',
                    fontSize: 14
                }}>
                    <div>Name</div>
                    <div>Email</div>
                    <div>Status</div>
                </div>
                {accountSharing.length === 0 ? (
                    <div style={{ padding: '14px 12px', color: '#666', fontSize: 14 }}>
                        No invitations yet.
                    </div>
                ) : (
                    accountSharing.map((row, idx) => {
                        const name = row.name || row.full_name || row.user_name || '-';
                        const email = row.email || row.invited_email || '-';
                        const status = row.status || row.invite_status || 'pending';
                        return (
                            <div
                                key={row.id || idx}
                                style={{
                                    display: 'grid',
                                    gridTemplateColumns: '2fr 2fr 1fr',
                                    gap: 8,
                                    padding: '10px 12px',
                                    borderTop: '1px solid #f0f0f3',
                                    alignItems: 'center',
                                    fontSize: 14
                                }}
                            >
                                <div>{name}</div>
                                <div style={{ color: '#333' }}>{email}</div>
                                <div>
                                    <span style={{
                                        display: 'inline-block',
                                        padding: '2px 8px',
                                        borderRadius: 999,
                                        background: status === 'active' ? '#dcfce7' : status === 'invited' ? '#e0e7ff' : '#fef3c7',
                                        color: status === 'active' ? '#166534' : status === 'invited' ? '#3730a3' : '#92400e',
                                        border: '1px solid rgba(0,0,0,0.06)'
                                    }}>{String(status).toLowerCase()}</span>
                                </div>
                            </div>
                        );
                    })
                )}
            </div>
        </div>
    );
};

export default AccountSharing;
